<template>
  <v-avatar v-if="params.value !== undefined" size="18" color="#333">
    <span class="text-white text-h5">{{ params.value }}</span>
  </v-avatar>
</template>

<script>
export default { name: 'CellPriorityBadgeRenderer' };
</script>

<style lang="scss" scoped></style>
